<template>
  <div class="matrix-gravity">
    <div v-for="(item, index) in issue.items" :key="item.id">
      <div class="option-title">
        <span>{{ item.content.text }}</span>
      </div>
      <div class="option-slider">
        <w-slider
          :min="issue.min"
          :max="issue.max"
          :value="item.value"
          @input="onSliderChange($event, item)"
          :show-input="true"
        />
      </div>
    </div>
    <div class="text-right mt-2">
      <span>比重总和：</span>
      <span :class="{ 'text-red': isError }">
        <span>{{ currentValue }}</span>
        <!--        /-->
        <!--        <span>{{ totalValue }}</span>-->
      </span>
    </div>
  </div>
</template>

<script>
import WSlider from '@/questions/components/WSlider'

export default {
  name: 'MatrixGravity',
  changeExpr: 'currentValue',
  components: { WSlider },
  computed: {
    currentValue() {
      return this.getCurrentValue()
    },
    totalValue() {
      return this.issue.totalValue
    },
    isError() {
      return this.currentValue !== this.totalValue
    }
  },
  methods: {
    getCurrentValue(exclusiveItem) {
      return this.issue.items.reduce((preValue, item) => {
        if (exclusiveItem && exclusiveItem.id === item.id) {
          return preValue + 0
        }
        return preValue + parseInt(item.value)
      }, 0)
    },
    onSliderChange(value, item, index) {
      // const items = this.issue.items
      item.value = value
      // if (items.length === 2 && false) {
      //   if (items.every(item => item.value == '0') && value == '0') {
      //     // TODO
      //   } else {
      //     items.forEach(item => {
      //       item.value = this.issue.totalValue - parseInt(value)
      //     })
      //   }
      //   item.value = value
      // } else {
      //   // let v = this.issue.totalValue - this.getCurrentValue(item)
      //   item.value = value
      //   // console.log(value)
      //   // this.$nextTick(() => {
      //   //   item.value = Math.min(v, value)
      //   // })
      // }
    }
  }
}
</script>
